import { render, staticRenderFns } from "./sss_zhuanlan.vue?vue&type=template&id=17cc499e&scoped=true"
import script from "./sss_zhuanlan.vue?vue&type=script&lang=js"
export * from "./sss_zhuanlan.vue?vue&type=script&lang=js"
import style0 from "./sss_zhuanlan.vue?vue&type=style&index=0&id=17cc499e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cc499e",
  null
  
)

export default component.exports